import type { PlacesType } from 'react-tooltip'

export const HINT_ID = 'hint'

/** Spread onto any element to give it a hover/focus tooltip: `<button {...hint('Close')}>`. */
export function hint(content: string, place: PlacesType = 'bottom') {
  return {
    'data-tooltip-id': HINT_ID,
    'data-tooltip-content': content,
    'data-tooltip-place': place,
  } as const
}
